import React, {useRef} from 'react';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItem from "@material-ui/core/ListItem";
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import SarasTooltip from '../../notifications/SarasTooltip';

const SarasListItem = (props)=>{
    const itemRef = useRef();
    const Icon = props.ListIcon;

    const handleClick = (e) => {
        if (props.onclick) {
            props.onclick(e, itemRef);
        }
    }

    return(
      <SarasTooltip title={props.title} tooltipAlign='right'>
        <div key={props.index} ref={itemRef}>
            <ListItem style={props.listItemStyle} onClick={handleClick}
                className={props.listItemClass}>
                {props.children}
                {!!Icon &&(
                <ListItemIcon className={props.listIconClass} style={props.listIconStyle}>
                    <Icon className={props.iconClass} style={props.iconStyle}/>
                </ListItemIcon>
                )}
                {
                    !!props.text &&(<ListItemText style={props.listItemTextStyle}>{props.text}</ListItemText>)
                }
                {props.executeBeforeEnd}
                
            </ListItem>
            
            {props.divider?<Divider variant="middle" />:''}
        </div>
      </SarasTooltip>
    )
}

export default SarasListItem
